import { render } from "./AddressForm.vue?vue&type=template&id=6b57d9ac&ts=true"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__